module.exports = __webpack_public_path__ + "img/face57.a337cbf0.gif";